import { useEffect, useMemo, useState } from "react";
import { useAzureStorageBlobs } from "./useAzureStorageBlobs";
import { isBefore } from "date-fns";
export const usePlatformNotifications = (options) => {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(false);
    const { notificationId, storageContainer, storageUrl, authToken, tenantId, applicationId } = options;
    const { getNotifications, containerClient } = useAzureStorageBlobs({
        authToken,
        storageContainer,
        storageUrl,
    });
    useEffect(() => {
        fetchBlob();
    }, []);
    const notification = useMemo(() => notifications.find((item) => item.id === notificationId), [notifications]);
    function blobFolderUriBuilder({ tenantId, applicationId }) {
        return `${tenantId}/${applicationId}/`;
    }
    const fetchBlob = async () => {
        setLoading(true);
        try {
            for await (const response of containerClient.listBlobsFlat({ prefix: blobFolderUriBuilder({ tenantId, applicationId }) }).byPage({ maxPageSize: 20 })) {
                const blobs = await Promise.all(response.segment.blobItems.map((item) => getNotifications(item.name)));
                const notFiltered = blobs.flat();
                setNotifications((prev) => [...prev, ...notFiltered]
                    .filter((value, index, self) => index === self.findIndex((t) => t.id === value.id))
                    .sort((a, b) => (isBefore(new Date(b.notificationStartDate), new Date(a.notificationStartDate)) ? -1 : 1)));
            }
        }
        finally {
            setLoading(false);
        }
    };
    return {
        notifications,
        notification,
        loading,
    };
};
//# sourceMappingURL=usePlatformNotifications.js.map